import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent{

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackbar: MatSnackBar
  ) { }

  get hasTitle(): boolean {
    return this.data.title && this.data.title.trim().length > 0;
  }

  runAction() {
    this.data.onAction?.();
    this.snackbar.dismiss();
  }

}
